const DEFECT_STATUS_NEW = "Новый";
const DEFECT_STATUS_AGREED = "Согласован";
const DEFECT_STATUS_UPDATED = "Обновлен";
const DEFECT_STATUS_CLOSED = "Закрыт";
const DEFECT_STATUS_REMOVED = "Удален";
const DEFECT_STATUS_REJECTED = "Отклонен";

const DEFECT_STATUS_NEW_ID = 1;
const DEFECT_STATUS_AGREED_ID = 2;
const DEFECT_STATUS_UPDATED_ID = 3;
const DEFECT_STATUS_CLOSED_ID = 5;
const DEFECT_STATUS_REMOVED_ID = 6;
const DEFECT_STATUS_REJECTED_ID = 7;

const UNLOADING_MK_SENT = "Отправлен";
const UNLOADING_MK_NOT_SENT = "Не отправлен";
const UNLOADING_MK_ERROR = "Ошибка";

const GRID_TYPE_HEATSUPPLY = 1;
const GRID_TYPE_WATERSUPPLY = 2;
const GRID_TYPE_GASCOMMUNICATION = 3;
const GRID_TYPE_LIGHTING = 4;
const GRID_TYPE_DRAINAGE = 5;
const GRID_TYPE_POWERSUPPLY = 6;

const REGISTER_DEFECTS = "registerDefects"; // Реестр дефектов
const REGISTER_PLANNED = "registerPlanned"; //Реестр плановых
const CONSISTENT_DEFECTS = "consistentDefects"; // Согласованные дефекты
const AGREED_PLANNED = "agreedPlanned"; //Согласованные плановые
const SETTINGS_DEFECT_KEY = "settings-0";
const SETTINGS_PLAN_KEY = "settings-1";

export {
  DEFECT_STATUS_NEW,
  DEFECT_STATUS_AGREED,
  DEFECT_STATUS_UPDATED,
  DEFECT_STATUS_CLOSED,
  DEFECT_STATUS_REMOVED,
  DEFECT_STATUS_REJECTED,
  DEFECT_STATUS_NEW_ID,
  DEFECT_STATUS_AGREED_ID,
  DEFECT_STATUS_UPDATED_ID,
  DEFECT_STATUS_CLOSED_ID,
  DEFECT_STATUS_REMOVED_ID,
  DEFECT_STATUS_REJECTED_ID,
  UNLOADING_MK_SENT,
  UNLOADING_MK_NOT_SENT,
  UNLOADING_MK_ERROR,
  GRID_TYPE_HEATSUPPLY,
  GRID_TYPE_WATERSUPPLY,
  GRID_TYPE_GASCOMMUNICATION,
  GRID_TYPE_LIGHTING,
  GRID_TYPE_DRAINAGE,
  GRID_TYPE_POWERSUPPLY,
  REGISTER_DEFECTS,
  REGISTER_PLANNED,
  CONSISTENT_DEFECTS,
  AGREED_PLANNED,
  SETTINGS_DEFECT_KEY,
  SETTINGS_PLAN_KEY,
};
